// extracted by mini-css-extract-plugin
export default {"input":"FuzzySearch_input__ZoaNQ","file":"FuzzySearch_file__8Go7d","item":"FuzzySearch_item__IsPDK","icon":"FuzzySearch_icon__2zdJi"};